// extracted by mini-css-extract-plugin
export default {"editorWrapper":"TextEditor_editorWrapper__xXUBA","toolbar":"TextEditor_toolbar__GQh5f","editor":"TextEditor_editor__Hichl"};